import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { WrapperHttpService } from '../../../../services/wrapper-http-service';
import { API_URL } from '../../../../../services/config';
import { ShipmentPlannerProfileDetails, ShipmentPlannerProfileModel } from '../models';
import { ShipmentPlannerProfileEndpoint } from '../constants/shipment-planner-profile-endpoint';

@Injectable({
  providedIn: 'root',
})
export class ShipmentPlannerProfileItemBriefService {
  constructor(private http: WrapperHttpService) {}

  saveShipmentPlannerProfile(body: Partial<ShipmentPlannerProfileDetails>): Observable<ShipmentPlannerProfileDetails> {
    const url = `${API_URL}${ShipmentPlannerProfileEndpoint.Base}${ShipmentPlannerProfileEndpoint.Profiles}`;
    return this.http.withLoading().patch<ShipmentPlannerProfileModel>(url, body);
  }

  cloneShipmentPlannerProfile(body: Partial<ShipmentPlannerProfileDetails>): Observable<ShipmentPlannerProfileDetails> {
    const url = `${API_URL}${ShipmentPlannerProfileEndpoint.Base}${ShipmentPlannerProfileEndpoint.Profiles}${ShipmentPlannerProfileEndpoint.Clone}`;
    return this.http.withLoading().post<ShipmentPlannerProfileDetails>(url, body);
  }

  deleteShipmentPlannerProfile(profileId: number): Observable<ShipmentPlannerProfileModel> {
    const url = `${API_URL}${ShipmentPlannerProfileEndpoint.Base}${ShipmentPlannerProfileEndpoint.Profiles}/${profileId}`;
    return this.http.withLoading().delete<ShipmentPlannerProfileModel>(url);
  }

  getShipmentDefaultProfileAffectedUsers(profileId: number): Observable<number> {
    const url = `${API_URL}${ShipmentPlannerProfileEndpoint.Base}${ShipmentPlannerProfileEndpoint.Profiles}${ShipmentPlannerProfileEndpoint.Default}${ShipmentPlannerProfileEndpoint.Usage}/${profileId}`;
    return this.http.withLoading().get<number>(url);
  }
}
